import { useEffect, useState } from 'react';
import { IOptions } from 'tailwind-datepicker-react/types/Options';
import Datepicker from 'tailwind-datepicker-react';

import '../scss/components/customdatepicker.scss';
import moment from 'moment';
import { CustomDatePickerProps } from '../interface/interface';

const CustomDatePicker = (props: CustomDatePickerProps) => {
  const [show, setShow] = useState<boolean>(false);
  const { handleDate, value, isSASEnabled = false } = props;
  const [formattedDate, setFormattedDate] = useState<string>('');

  useEffect(() => {
    if (value) {
      formatDate(value);
    }
  }, [value]);

  const formatDate = (date: Date) => {
    setFormattedDate(moment(date).format('DD/MM/YYYY'));
  };

  return (
    <div className="custom-date-picker">
      <Datepicker
        onChange={(date: Date) => {
          formatDate(date);
          handleDate(date, props?.id);
        }}
        show={!isSASEnabled && show}
        setShow={() => setShow(!show)}
        value={value}
        classNames={props?.className}
        options={
          {
            theme: {
              background: '',
              text: '',
              todayBtn: '',
              clearBtn: '',
              icons: '',
              disabledText: 'opacity-50',
              input: '',
              inputIcon: '',
              selected: '',
            },
            defaultDate: null,
            autoHide: true,
            ...(props?.maxDate && { maxDate: new Date() }),
            ...(props?.minDate && { minDate: new Date() }),
            todayBtn: false,
            datepickerClassNames: 'date-picker',
            clearBtn: false,
            inputIdProp: 'date',
            inputPlaceholderProp: '-',
            inputDateFormatProp: {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            },
          } as IOptions
        }
      >
        <div>
          <input
            className="border rounded-md p-2 w-full border-secondary-cornflowerblue-400 "
            type="text"
            placeholder="-"
            value={formattedDate}
            onFocus={() => setShow(!show)}
            onKeyDown={(event) => {
              if (!props.readonly && event.key === 'Backspace') {
                setFormattedDate('');
                handleDate(undefined as any, props?.id);
              }
            }}
            readOnly
          />
        </div>
      </Datepicker>
    </div>
  );
};

export default CustomDatePicker;
